import { mapAtom } from '../../atoms/map/map'
import { findLayer } from '../utils/findLayer'

import { changelogRemoveDepotFeatures } from './utils/changelogRemoveDepotFeatures'
import { changelogAddDepotFeatures } from './utils/changelogAddDepotFeatures'
import { changelogUpdateDepotFeatures } from './utils/changelogUpdateDepotFeatures'

export const createUpdateDepotFeaturesFromChangelog = (
  markers: uui.domain.ui.map.markers.MapMarkers['depot'],
  mapStyles: uui.domain.ui.map.markers.MapStyles['depot'],
  selection: Set<string>,
  changelog: uui.domain.api.Changelog,
) => {
  // ATTENTION: Currently all changelog are applied as soon as they arrive, also when the map is not visible
  // `ignoreSelection` it will be used to avoid to apply any selection information to the map when applying cached updater functions.
  // after all cached updates will be applied a refresh selection action will be required
  return async (_ignoreSelection: boolean = false) => {
    const map = mapAtom.map
    const layer = findLayer(map, 'depot')

    // remove
    await changelogRemoveDepotFeatures(layer, selection, changelog.remove.values())

    // add
    await changelogAddDepotFeatures(layer, markers, mapStyles, selection, changelog.add.values())

    // update
    await changelogUpdateDepotFeatures(
      layer,
      markers,
      mapStyles,
      selection,
      changelog.update.values(),
    )
  }
}
